import {ExitLayer} from '@travel-frontend/ui-components';

import {config} from '@/config';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';
import {useHeaderConfig} from '@/modules/common/hooks/useHeaderConfig';
import {useTracking} from '@/modules/common/hooks/useTracking';

export const ExitIntentLayerDefault = () => {
  const currentPage = useCurrentPage();
  const {dispatchGenericTrackingEvent} = useTracking();
  const headerConfig = useHeaderConfig();
  const phone = config.exitLayer[currentPage].hotline;

  const handleClose = () => {
    dispatchGenericTrackingEvent({
      event: 'find',
      event_action: 'exit_layer_closed',
    });
  };

  return (
    <ExitLayer
      delay={15_000}
      config={{
        phoneNumbers: {lg: phone, md: phone, sm: phone},
        openingHours: headerConfig?.hotline?.openingHours,
        specials: headerConfig?.hotline?.specials,
      }}
      onClose={handleClose}
      onCTAClick={handleClose}
      onLoad={() => {
        dispatchGenericTrackingEvent({
          event: 'find',
          event_action: 'exit_layer_loaded',
        });
      }}
    />
  );
};
